import { Dispatch } from "redux";
import { setMessageTemplatesLoading, setMessageTemplates } from "@redux/actions/message-templates-actions";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { getMessageTemplatesRequest } from "@requests/axnadmin-core/get-message-templates";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { formatMessageTemplates } from "@formatters/message-templates/message-template-formatter";

export const getMessageTemplatesReduxRequest = (dispatch: Dispatch) => async (
    axnCompanies: Array<AxnCompany>
): Promise<Array<FormattedMessageTemplate>> => {
    dispatch(setMessageTemplatesLoading(true));
    const { data, error } = await getMessageTemplatesRequest();
    if (data?.selfServiceVerificationMessageTemplates) {
        const formattedMessageTemplates = formatMessageTemplates(data.selfServiceVerificationMessageTemplates, axnCompanies);
        dispatch(setMessageTemplates(formattedMessageTemplates));
        return formattedMessageTemplates;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getMessageTemplates.error.title,
                resources.requests.getMessageTemplates.error.message
            );
        }
        dispatch(setMessageTemplatesLoading(false));
        return null;
    }
};